export default function RatioBar({ label, value, threshold, unit = "%" }) {
  const pass     = value < threshold;
  const pct      = Math.min((value / threshold) * 100, 100);
  const color    = pass ? "#00C896" : "#FF4D6D";
  const isExtreme = value > threshold * 3; // More than 3x the threshold

  // Reason messages for extreme ratios
  const getExtremeReason = (label, value) => {
    if (label.toLowerCase().includes("debt")) {
      return `This company carries extremely high debt — often due to a financial services, banking or insurance subsidiary. Under AAOIFI standards debt must stay below ${threshold}% of market cap.`;
    }
    if (label.toLowerCase().includes("interest")) {
      return `This company earns significant interest income — likely from a banking, lending or financial services division. AAOIFI limits interest income to ${threshold}% of total revenue.`;
    }
    if (label.toLowerCase().includes("impure")) {
      return `This company has high impure income — revenue from haram activities such as interest, alcohol, gambling or other prohibited sources exceeds the ${threshold}% AAOIFI threshold.`;
    }
    if (label.toLowerCase().includes("cash")) {
      return `This company holds an unusually high level of cash and liquid assets relative to its market value. This may indicate a holding company or financial institution structure.`;
    }
    if (label.toLowerCase().includes("receivable")) {
      return `This company has very high accounts receivable relative to total assets — common in financial institutions that extend credit or loans as their primary business.`;
    }
    return `This ratio significantly exceeds the AAOIFI threshold of ${threshold}${unit} — indicating a serious Shariah compliance concern.`;
  };

  return (
    <div style={{
      background: "rgba(255,255,255,0.02)",
      border: `1px solid ${isExtreme && !pass ? "rgba(255,77,109,0.15)" : "rgba(255,255,255,0.06)"}`,
      borderRadius: 12, padding: "16px 20px", marginBottom: 10,
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 500, color: "#C8CDD8", marginBottom: 2 }}>{label}</div>
          <div style={{ fontSize: 11, color: "#4A5568" }}>Threshold: &lt;{threshold}{unit}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 20, fontWeight: 700, fontFamily: "'Syne',sans-serif", color }}>
            {value}{unit}
          </div>
          <div style={{ fontSize: 10, fontWeight: 700, color }}>
            {pass ? "✓ PASS" : "✗ FAIL"}
          </div>
        </div>
      </div>
      <div style={{ height: 5, background: "rgba(255,255,255,0.05)", borderRadius: 99 }}>
        <div style={{
          height: "100%", borderRadius: 99, width: `${pct}%`,
          background: pass ? "linear-gradient(90deg,#00C896,#4FFFCE)" : "linear-gradient(90deg,#FF4D6D,#FF8FA3)",
          transition: "width 0.8s cubic-bezier(0.16,1,0.3,1)",
        }} />
      </div>

      {/* Extreme ratio explanation */}
      {isExtreme && !pass && (
        <div style={{ marginTop: 10, padding: "8px 12px", background: "rgba(255,77,109,0.06)", border: "1px solid rgba(255,77,109,0.15)", borderRadius: 8, fontSize: 11, color: "#9CA3AF", lineHeight: 1.7 }}>
          ⚠️ {getExtremeReason(label, value)}
        </div>
      )}
    </div>
  );
}
